import VehicleCardBa from './ba/quotes/vehicle_card';
import VehicleCardBg from './bg/quotes/vehicle_card';
import VehicleCardCn from './cn/quotes/vehicle_card';
import VehicleCardTw from './tw/quotes/vehicle_card';
import VehicleCardDe from './de/quotes/vehicle_card';
import VehicleCardDk from './dk/quotes/vehicle_card';
import VehicleCardEn from './en/quotes/vehicle_card';
import VehicleCardEs from './es/quotes/vehicle_card';
import VehicleCardFi from './fi/quotes/vehicle_card';
import VehicleCardFr from './fr/quotes/vehicle_card';
import VehicleCardGr from './gr/quotes/vehicle_card';
import VehicleCardHr from './hr/quotes/vehicle_card';
import VehicleCardHu from './hu/quotes/vehicle_card';
import VehicleCardIt from './it/quotes/vehicle_card';
import VehicleCardJp from './jp/quotes/vehicle_card';
import VehicleCardLt from './lt/quotes/vehicle_card';
import VehicleCardLv from './lv/quotes/vehicle_card';
import VehicleCardMe from './me/quotes/vehicle_card';
import VehicleCardMk from './mk/quotes/vehicle_card';
import VehicleCardMt from './mt/quotes/vehicle_card';
import VehicleCardNl from './nl/quotes/vehicle_card';
import VehicleCardPl from './pl/quotes/vehicle_card';
import VehicleCardPt from './pt/quotes/vehicle_card';
import VehicleCardRs from './rs/quotes/vehicle_card';
import VehicleCardSe from './se/quotes/vehicle_card';
import VehicleCardTr from './tr/quotes/vehicle_card';
import VehicleCardUs from './en-us/quotes/vehicle_card';

export default {
    messages: {
        ba: { VehicleCard: VehicleCardBa },
        bg: { VehicleCard: VehicleCardBg },
        cn: { VehicleCard: VehicleCardCn },
        tw: { VehicleCard: VehicleCardTw },
        de: { VehicleCard: VehicleCardDe },
        dk: { VehicleCard: VehicleCardDk },
        en: { VehicleCard: VehicleCardEn },
        'en-us': { VehicleCard: VehicleCardUs },
        es: { VehicleCard: VehicleCardEs },
        fi: { VehicleCard: VehicleCardFi },
        fr: { VehicleCard: VehicleCardFr },
        gr: { VehicleCard: VehicleCardGr },
        hr: { VehicleCard: VehicleCardHr },
        hu: { VehicleCard: VehicleCardHu },
        it: { VehicleCard: VehicleCardIt },
        jp: { VehicleCard: VehicleCardJp },
        lt: { VehicleCard: VehicleCardLt },
        lv: { VehicleCard: VehicleCardLv },
        me: { VehicleCard: VehicleCardMe },
        mk: { VehicleCard: VehicleCardMk },
        mt: { VehicleCard: VehicleCardMt },
        mx: { VehicleCard: VehicleCardEs },
        nl: { VehicleCard: VehicleCardNl },
        pl: { VehicleCard: VehicleCardPl },
        pt: { VehicleCard: VehicleCardPt },
        rs: { VehicleCard: VehicleCardRs },
        se: { VehicleCard: VehicleCardSe },
        tr: { VehicleCard: VehicleCardTr },
    },
};
